export class JuicioDiagnostico {
    cip: string;
    fecha: string;
    texto: string;
    linea: string;
    hora: string;
    visita: string;
    exObservaciones: string;
    codigo: string;
    textoHTMLClob: string;
    numeroExpediente: string;
    dniMedico: string;
    idExplotex: string;
    dniBorrado: string;
    motivoBorrado: string;
    accion: string;
}



// WEBPACK FOOTER //
// ./src/models/juiciodiagnostico.ts